<template>
  <div class="addCardPage">
    <job-header-simple
      :header_title="idCate ? '认证银行卡' : '添加银行卡'"
    ></job-header-simple>
    <van-field
      readonly
      label="姓 名"
      label-width="1.9rem"
      :value="ruleForm.userName"
    />
    <van-field
      readonly
      label="证件号码"
      label-width="1.9rem"
      :value="ruleForm.idNumber"
    />
    <van-field
      v-model="account"
      type="tel"
      label-width="1.9rem"
      clearable
      label="银行卡号"
      placeholder="请绑定持卡人本人的银行卡"
      maxlength="23"
      @input="
        account = account.replace(/[^\d]/g, '').replace(/....(?=.)/g, '$& ')
      "
      @blur="changeAccount"
    ></van-field>
    <van-field
      readonly
      label="银行名称"
      label-width="1.9rem"
      type="tel"
      :value="ruleForm.bankName"
    />
    <van-field
      class="reserved-phone"
      label="预留手机号"
      label-width="1.9rem"
      v-model="ruleForm.bankMobile"
      @input="
        ruleForm.bankMobile = ruleForm.bankMobile
          .replace(/[^\d]/g, '')
          .replace(/(\d{3})(\d{4})/, '$1 $2 ')
      "
      placeholder="请输入预留手机号码"
      maxlength="13"
    />
    <van-field
      label="所属城市"
      label-width="1.9rem"
      v-model="ruleForm.cityName"
      readonly
      @click="isCityClicked = true"
      placeholder="请选择所属城市"
    />
    <div class="bottom">
      <van-button
        type="info"
        :disabled="isSubmitDisabled"
        :loading="loading"
        size="large"
        round
        class="btn_theme"
        @click="handleAdd"
        >确认提交</van-button
      >
    </div>
    <van-popup v-model="isCityClicked" position="bottom">
      <van-picker
        title="城市选择"
        show-toolbar
        :columns="cityList"
        @confirm="handleCityConfirm"
        @cancel="isCityClicked = false"
      />
    </van-popup>
    <p class="tip">*新增银行卡后，请在我的协议同步修改</p>
    <div class="pageInfo">
      <p>绑定说明：</p>
      <p>
        1、仅支持绑定账号本人的储蓄卡<span class="red-tip"
          >（请绑定一类卡）</span
        >，不支持信用卡和国际卡；
      </p>
      <p>
        2、添加银行卡时会进行实名认证，请仔细核对姓名、证件号码和银行账号信息；
      </p>
      <p>
        3、认证失败次数<span class="red-tip">超过5次</span
        >，账号将被锁定，24小时后自动解锁。
      </p>
      <p>
        4、认证失败时请仔细核对姓名、证件号码和银行卡号是否正确，并核实银行预留证件信息是否为当前身份信息；
      </p>
      <p>
        5、如果<span class="red-tip">姓名或证件号码错误</span
        >，请找合作企业进行更正后再进行添加；
      </p>
      <p>6、如果信息无误，请联系发卡银行，核实当前银行卡是否已开通认证权限；</p>
    </div>
  </div>
</template>
<script>
import { Field, Button, Cell, CellGroup, Toast, Popup, Picker } from 'vant'
import jobHeaderSimple from '@/components/header/header.vue'
import store from '@/store'
import { employeeSaveToUserToCode } from '@/api/employee/request'
import { getAllCity } from '@/api/contract/taskRequest'
import api from '@/api/list'
import { mapGetters } from 'vuex'
export default {
  components: {
    [Field.name]: Field,
    [Button.name]: Button,
    [Cell.name]: Cell,
    [CellGroup.name]: CellGroup,
    [Toast.name]: Toast,
    [Popup.name]: Popup,
    [Picker.name]: Picker,
    jobHeaderSimple,
  },
  data() {
    return {
      timer: null,
      isSubmitDisabled: false,
      idCate: this.$route.query.id ? true : false,
      //用于存储上一次的银行卡号
      lastAccount: '',
      account: this.$route.query.account,
      loading: false,
      isCityClicked: false,
      cityList: [],
      types: '',
      // isShow: false,
      ruleForm: {
        id: this.$route.query.id,
        idNumber: null,
        userName: null,
        account: this.$route.query.account,
        bankMobile: '',
        bankName: this.$route.query.bankName,
        cityName: '',
        cityId: '',
      },
    }
  },
  computed: {
    ...mapGetters(['userInfo']),
  },
  watch: {
    account: function() {
      if (this.account && typeof this.account != 'undefined') {
        this.ruleForm.account = this.account.replace(/\s/g, '')
      }
    },
  },
  created() {
    if (
      this.$route.query.type &&
      typeof this.$route.query.type != 'undefined'
    ) {
      this.types = this.$route.query.type
    }
    getAllCity().then((res) => {
      this.cityList = res.data.data
    })
  },
  methods: {
    changeAccount() {
      if (
        !this.ruleForm.account ||
        typeof this.ruleForm.account == 'undefined'
      ) {
        Toast.fail('请填写银行卡号!')
        return false
      }
      if (
        this.ruleForm.account.length < 16 ||
        this.ruleForm.account.length > 19
      ) {
        Toast.fail('银行卡号位数限定16~19位!')
        return false
      }
      const toastLoading = Toast.loading({
        message: '正在获取银行卡号...',
        forbidClick: true,
        loadingType: 'spinner',
        duration: 0,
      })
      employeeSaveToUserToCode({
        code: this.ruleForm.account,
        id: this.ruleForm.id,
      }).then((res) => {
        toastLoading.clear() //关闭加载效果
        if (res.data.status == '200') {
          if (
            res.data.data.type == '' ||
            res.data.data.type == null ||
            res.data.data.type == undefined
          ) {
            Toast.fail('未知银行，请更换银行卡或联系客服')
          } else if (
            res.data.data.type == '储蓄卡' ||
            res.data.data.type == '借记卡'
          ) {
            if (res.data.data.code == 1) {
              Toast.fail(res.data.data.name + '存在风险交易，请更换银行卡')
            } else if (res.data.data.code == 2) {
              Toast.fail('暂不支持' + res.data.data.name + '，请更换银行卡')
            } else if (res.data.data.code == 3) {
              Toast.fail(
                res.data.data.name +
                  '银行' +
                  res.data.data.bin +
                  '不支持，请更换银行卡'
              )
            } else {
              this.ruleForm.bankName = res.data.data.name
            }
          } else {
            Toast.fail('仅支持储蓄卡，请输入正确的储蓄卡号!!')
          }
        } else {
          Toast.fail(res.data.message)
        }
      })
    },

    handleAdd() {
      if (this.ruleForm.account == this.lastAccount) {
        Toast.fail('请更换银行卡号!')
        return false
      }
      if (!this.ruleForm.cityName) {
        Toast.fail('请选择城市!')
        return false
      }
      if (
        !this.ruleForm.account ||
        typeof this.ruleForm.account == 'undefined'
      ) {
        Toast.fail('请填写银行卡号!')
        return false
      }
      if (
        this.ruleForm.account.length < 16 ||
        this.ruleForm.account.length > 19
      ) {
        Toast.fail('银行卡号位数限定16~19位!')
        return false
      }

      if (
        !this.ruleForm.bankMobile ||
        typeof this.ruleForm.bankMobile == 'undefined'
      ) {
        Toast.fail('请填写预留手机号码!')
        return false
      }
      if (this.ruleForm.bankMobile.replace(/\s/g, '').length != 11) {
        Toast.fail('手机号码位数限定11位!')
        return false
      }

      this.loading = true
      let addr = this.ruleForm.cityName.split('/')
      this.isSubmitDisabled = true
      let params = {
        id: this.ruleForm.id,
        userName: this.ruleForm.userName,
        bankName: this.ruleForm.bankName,
        account: this.ruleForm.account,
        bankMobile: this.ruleForm.bankMobile,
        provinceName: addr[0],
        cityName: addr[1],
      }

      api
        .bankCardSave(params, { method: 'POST' })
        .then((res) => {
          if (res.data.status == '200') {
            Toast.success('已成功添加')
            this.lastAccount = ''
            this.$router.push({
              path: '/card',
              query: {
                type: this.types,
                contractId: this.$route.query.obj,
              },
            })
          } else if (res.data.status == '10001') {
            //保存上次错误的银行卡号
            this.lastAccount = this.ruleForm.account
            Toast.fail('认证失败，请核对或更换银行卡号！')
          } else {
            Toast.fail(res.data.message)
          }
          this.loading = false
          this.isSubmitDisabled = false
        })
        .catch((error) => {
          this.loading = false
          this.isSubmitDisabled = false
          Toast.fail(error.response.message)
        })
    },
    handleCityConfirm(value, value2) {
      //console.log(value, value2); //value为text数组  value2为对应的id数组
      this.ruleForm.cityId = this.cityList[value2[0]].children[value2[1]].id
      this.ruleForm.cityName = value.join('/')
      //console.log(this.ruleForm.cityId);
      //   if (value[0] == value[1]) {
      //     this.ruleForm.cityName = value[0];
      //   } else {
      //     this.ruleForm.cityName = value.join("/");
      //   }

      this.isCityClicked = false
    },
  },
  mounted: function() {
    if (
      this.userInfo &&
      this.userInfo !== undefined &&
      this.userInfo !== null
    ) {
      this.ruleForm.idNumber = this.userInfo.idNumber
      this.ruleForm.userName = this.userInfo.name
    } else {
      this.timer = setTimeout(() => {
        if (
          this.userInfo &&
          this.userInfo !== undefined &&
          this.userInfo !== null
        ) {
          this.ruleForm.idNumber = this.userInfo.idNumber
          this.ruleForm.userName = this.userInfo.name
        }
      }, 1000)
    }

    document.getElementsByTagName('body')[0].className = 'bg_f'
  },
  beforeDestroy: function() {
    if (this.timer) {
      clearTimeout(this.timer)
    }
    document.body.removeAttribute('class', 'bg_f')
  },
}
</script>

<style lang="less" scoped>
.tip {
  color: #ff3838;
  padding-left: 24px;
  font-size: 14px;
}
.pageInfo {
  font-size: 12px;
  color: #999;
  line-height: 1.5;
  padding: 10px 24px;
  p {
    margin-bottom: 4px;
    .red-tip {
      color: #ff022f;
      font-weight: 600;
    }
  }
}
.addCardPage {
  padding-top: 20px;
  h1 {
    font-size: 20px;
    color: #666;
    text-align: center;
    margin-bottom: 30px;
  }
  header {
    padding: 12px 20px;
    font-size: 14px;
    color: #999;

    span {
      color: #000;
      font-weight: 600;

      &.text-right {
        color: #ff976a;
        font-weight: normal;
      }
    }
  }

  /deep/ .van-field__label {
    width: 60px;
  }

  .showBig {
    position: absolute;
    left: 10px;
    bottom: 46px;
    background: #fff;
    border-radius: 10px;
    padding: 4px 12px;
    z-index: 9999;
    line-height: 30px;
    font-size: 20px;
    color: #444;
  }
}
.bottom {
  padding: 40px;
}
</style>

<style lang="less">
.reserved-phone {
  .van-field__label {
    span {
      white-space: nowrap;
    }
  }
}
</style>
